import React, { FC,  useEffect, useState } from "react";
import { RootState } from '../../../../rootReducer';
import { AppDispatch } from '../../../../store';
import { connect } from 'react-redux';
import { Modal, Button, Form } from 'antd';
import { ValidationModalDto, setValidationData } from "./AnnotationValidationModal.slice";
import { annotationCreationCanceled } from "../../Canvas/canvas.slice";


type Props = {
    validationModalData: ValidationModalDto;
    onSetValidationData: (dto: ValidationModalDto) => void;
    onCancelCreation: () => void;
};

const AnnotationValidationModal: FC<Props> = ({ 
    validationModalData,
    onSetValidationData,
    onCancelCreation
}) => {
    const [messageText, setMessageText] = useState<string>('');

    const onHideModal = () => {
      const dto: ValidationModalDto = { 
        showModal: false
      };
      onSetValidationData(dto);
      onCancelCreation();
    }
    
    useEffect(() => {
      let text = '';
      
      if (validationModalData.localizationMissingIssue) {
        text = 'Missing localization data from the ML service.';
      }

      if(!validationModalData.isShapeValid) {
        text = 'Selected annotation shape is invalid. ';
        if(validationModalData.overlappingIssue) {
          text += 'Annotation inside overlapping area is forbidden. ';
        }
        if(validationModalData.outOfBoundariesIssue) {
          text += 'Annotation must be inside image boundaries';
        }
      }
      setMessageText(text);
    }, [validationModalData]);

      return(
        <Modal 
          title='Annotation Validation'  
          visible={validationModalData.showModal}
          onCancel={() => onHideModal()}
          footer={
            <Button
              key='back'
              onClick={() => {
                onHideModal();
              }}
            >
            Close
            </Button>
        }
        >
        <Form>
          { messageText }
        </Form>
      </Modal>
      );
};

const mapStateToProps = (state: RootState) => ({
    validationModalData: state.annotationValidationModal.validationModalData,
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  onSetValidationData: (dto: ValidationModalDto) => dispatch(setValidationData(dto)),
  onCancelCreation: () => dispatch(annotationCreationCanceled(true))
});

export default connect(mapStateToProps, mapDispatchToProps)(AnnotationValidationModal);
